import {TextField, withWidth, WithWidthProps} from '@material-ui/core';
import React from 'react';

type TextFilterProps = {
  placeholder: string;
  value: string;
  onChange: (value: string) => any;
} & WithWidthProps;

const TextFilter = (props: TextFilterProps) => {
 return (
    <div style={{padding: '1em 0', display: 'flex', flexDirection: 'column'}}>
      <TextField
        id={`column-filter-${props.placeholder.toLowerCase()}`}
        label={props.placeholder}
        fullWidth
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        inputProps= {{'data-dd-privacy':"mask-user-input", 'aria-label':`${props.placeholder} filter`}}
      />
    </div>
  );
};

export default withWidth()(TextFilter);
